export const FlowLabelPrefix = {
  LINK: 'link',
};

export const SimulatorModes = {
  AUTO: 'auto',
  CHALLENGE: 'challenge',
  MANUAL: 'manual',
};
